/**
 * Desktop smooth scroll: Lenis + GSAP ScrollTrigger (GSAP ticker drives Lenis RAF).
 * Uses root/window scrolling (no #smooth-wrapper) so Horizon’s sticky header and
 * header.js scroll listeners (document.scrollingElement) keep working. Nested
 * Lenis wrapper + transform breaks sticky and window scroll integration.
 */
import Lenis from 'lenis'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const DESKTOP_MIN = 992

let lenis = null
/** @type {((time: number) => void) | null} */
let rafHandler = null

gsap.registerPlugin(ScrollTrigger)

function destroyLenis() {
  if (rafHandler) {
    gsap.ticker.remove(rafHandler)
    rafHandler = null
  }
  lenis?.destroy()
  lenis = null
  document.body.classList.remove('lenis-active')
  ScrollTrigger.refresh()
}

function initLenis() {
  if (lenis) return

  lenis = new Lenis({
    duration: 1.2,
    lerp: 0.1,
    smoothWheel: true,
  })

  lenis.on('scroll', ScrollTrigger.update)

  rafHandler = (time) => {
    lenis?.raf(time * 1000)
  }
  gsap.ticker.add(rafHandler)

  document.body.classList.add('lenis-active')
  ScrollTrigger.refresh()
}

function shouldUseLenis() {
  return (
    window.matchMedia(`(min-width: ${DESKTOP_MIN}px)`).matches &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )
}

function sync() {
  if (shouldUseLenis()) {
    initLenis()
  } else {
    destroyLenis()
  }
}

sync()
window.matchMedia(`(min-width: ${DESKTOP_MIN}px)`).addEventListener('change', sync)
window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', sync)
